export default "__VITE_ASSET__CRgxrLrD__"